export default function defer(func) {
  // wait until painting is happening
  if (typeof window !== 'undefined') {
    requestAnimationFrame(() => {
      // then defer the thing that you want to have happened until AFTER the painting...
      setTimeout(func)
    })
  }
}
